/*
 * Constants.
 */

export const onboardingGuideSlideWidth = '1084px';
export const onboardingGuideRightSideWidth = '542px';
export const onboardingGuideSlideHeight = '692px';
